import React, { useState } from 'react';
import Swal from 'sweetalert2';

function convertDropboxUrl(shareUrl) {
    const url = new URL(shareUrl.trim());
    if (!url.hostname.includes('dropbox.com')) throw new Error('Not a Dropbox URL');
    url.hostname = 'dl.dropboxusercontent.com';
    url.searchParams.delete('dl');
    url.searchParams.delete('st');
    return url.toString();
}

function DropboxUrlInput({ onUrl, style = {} }) {
    const [url, setUrl] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLoad = () => {
        if (!url.trim()) return;
        setLoading(true);
        try {
            const converted = convertDropboxUrl(url);
            onUrl(converted);
            setUrl('');
        } catch {
            Swal.fire({ timer: 2000, title: 'Error', text: 'Invalid Dropbox share URL.', icon: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', gap: '6px', marginTop: '6px', ...style }}>
            <input
                type="text"
                placeholder="Paste Dropbox share link…"
                value={url}
                onChange={e => setUrl(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleLoad(); } }}
                disabled={loading}
                style={{
                    flex: 1, fontSize: '13px', padding: '4px 8px',
                    borderRadius: '4px', border: '1px solid var(--th-6c4f9b)',
                    background: 'var(--lm-bg-1a1f2b)', color: 'var(--lm-tx-f5f5f5)', minWidth: 0,
                }}
            />
            <button
                type="button"
                onClick={handleLoad}
                disabled={!url.trim() || loading}
                style={{
                    padding: '4px 10px', background: '#0061FF', color: '#fff',
                    border: 'none', borderRadius: '4px', fontSize: '13px',
                    cursor: (!url.trim() || loading) ? 'not-allowed' : 'pointer',
                    opacity: (!url.trim() || loading) ? 0.6 : 1,
                    whiteSpace: 'nowrap',
                }}
            >
                Load URL
            </button>
        </div>
    );
}

export default DropboxUrlInput;
